import {BrowserRouter,Routes,Route} from "react-router-dom"
import Dashboard from "./pages/Dashboard"

import Login from "./components/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import Users from "./pages/user_pages/Users";


import AddUser from "./pages/user_pages/AddUser";
import EditUser from "./pages/user_pages/EditUser";


import Erga from "./pages/erga_pages/Erga";
import AddErga from "./pages/erga_pages/AddErga";
import ProfileErgo from "./pages/erga_pages/ProfileErgo";
import EditErgo from "./pages/erga_pages/EditErgo";

import ErgaCat from "./pages/erga_cat_pages/ErgaCat";
import AddErgaCat from "./pages/erga_cat_pages/AddErgaCat";
import EditErgoCat from "./pages/erga_cat_pages/EditErgoCat";


import Customer from "./pages/customer_pages/Customer";
import AddCustomer from "./pages/customer_pages/AddCustomer";
import EditCustomer from "./pages/customer_pages/EditCustomer";
import ProfileCustomer from "./pages/customer_pages/ProfileCustomer";

import Timologia from "./pages/timologia_pages/Timologia";
import AddTimologio from "./pages/timologia_pages/AddTimologio";
import EditTimologio from "./pages/timologia_pages/EditTimologio";
import ProfileTimologio from "./pages/timologia_pages/ProfileTimologio";

import Ekxorimena_Timologia from "./pages/ekxwrimeno_timologio_pages/Ekxorimena_Timologia";
import AddEkxorimeno_Timologio from "./pages/ekxwrimeno_timologio_pages/AddEkxorimeno_Timologio";
import EditEkxorimeno_Timologio from "./pages/ekxwrimeno_timologio_pages/EditEkxorimeno_Timologio";
import ProfileEkxorimenoTimologio from "./pages/ekxwrimeno_timologio_pages/ProfileEkxorimeno_Timologio";


import Paradotea from "./pages/paradotea_pages/Paradotea";
import AddParadoteo from "./pages/paradotea_pages/AddParadoteo";
import EditParadoteo from "./pages/paradotea_pages/EditParadoteo";
import ProfileParadoteo from "./pages/paradotea_pages/ProfileParadoteo";

import Daneia from "./pages/daneia_pages/Daneia";
import AddDaneia from "./pages/daneia_pages/AddDaneia";
import EditDaneia from "./pages/daneia_pages/EditDaneia";

import ProfileDaneia from "./pages/daneia_pages/ProfileDaneia";

import Tags from "./pages/tags_pages/Tags";
import AddTag from "./pages/tags_pages/AddTag"
import EditTags from "./pages/tags_pages/EditTags";
import ProfileTags from "./pages/tags_pages/ProfileTags";


import Doseis from "./pages/doseis_pages/Doseis";
import AddDoseis from "./pages/doseis_pages/AddDoseis"
import EditDoseis from "./pages/doseis_pages/EditDoseis"
import ProfileDoseis from "./pages/doseis_pages/ProfileDoseis"

import Ypoxreoseis from "./pages/ypoxreoseis_pages/Ypoxreoseis";
import AddYpoxreoseis from "./pages/ypoxreoseis_pages/AddYpoxreoseis";
import ProfileYpoxreoseis from "./pages/ypoxreoseis_pages/ProfileYpoxreoseis";
import EditYpoxreoseis from "./pages/ypoxreoseis_pages/EditYpoxreoseis";

import PaidView from "./pages/paid_pages/paidView";

import YpoxreoseisStatistics from "./pages/YpoxreoseisStatistics.jsx";

import { PrimeReactProvider } from 'primereact/api';
import { Button } from 'primereact/button'; // Importing PrimeReact Button component

import 'primereact/resources/themes/saga-blue/theme.css';  // theme
// import 'primereact/resources/themes/bootstrap4-light-blue/theme.css'
//import 'primereact/resources/primereact.min.css';          // core css
import 'primeicons/primeicons.css';                        // icons
import 'primeflex/primeflex.css';   


import './flags.css';
// import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';

import Tags2 from "./pages/wizard_pages/tags_pages2/Tags2";
import AddTag2 from "./pages/wizard_pages/tags_pages2/AddTag2";


import AddYpoxreoseis2 from "./pages/wizard_pages/ypoxreoseis_pages2/AddYpoxreoseis2";
import YpoxreoseisList2 from "./components/wizard_components/ypoxreoseis_components2/YpoxreoseisList2";

import AddDoseis2 from "./pages/wizard_pages/doseis_pages2/AddDoseis2"
import Doseis2 from "./pages/wizard_pages/doseis_pages2/Doseis2"

import MyStepper1 from "./pages/MyStepper1";
import MyStepper2 from "./pages/MyStepper2";

import Expenses_Display from "./pages/Expenses_Display";
import BudgetPage from './pages/BudgetPage'

import Customer2 from "./pages/wizard_pages/customer_pages2/Customer2";
import AddCustomer2 from "./pages/wizard_pages/customer_pages2/AddCustomer2";

import Erga2 from "./pages/wizard_pages/erga_pages2/Erga2";
import AddErga2 from "./pages/wizard_pages/erga_pages2/AddErga2";

import ErgaCat2 from "./pages/wizard_pages/erga_cat_pages2/ErgaCat2";
import AddErgaCat2 from "./pages/wizard_pages/erga_cat_pages2/AddErgaCat2";

import Paradotea2 from "./pages/wizard_pages/paradotea_pages2/Paradotea2";
import AddParadoteo2 from "./pages/wizard_pages/paradotea_pages2/AddParadoteo2";

import Timologia2 from "./pages/wizard_pages/timologia_pages2/Timologia2";
import AddTimologio2 from "./pages/wizard_pages/timologia_pages2/AddTimologio2";

import Ekxorimena_Timologia2 from "./pages/wizard_pages/ekxwrimeno_timologio_pages2/Ekxorimena_Timologia2";
import AddEkxorimeno_Timologio2 from "./pages/wizard_pages/ekxwrimeno_timologio_pages2/AddEkxorimeno_Timologio2";

import Stepper_Esoda1 from "./pages/Stepper_Esoda1";
import Stepper_Esoda2 from "./pages/Stepper_Esoda2";
import Stepper_Esoda3 from "./pages/Stepper_Esoda3";

import BudgetFormPage from "./pages/budget_pages/BudgetFormPage";

import KpisDashboard from "./pages/KpisDashboard.jsx";
// import KpisDashboard from "./pages/KpisDashboardnew.jsx";
import KpisDashboardTest from "./pages/KpisDashboardTest.jsx";
import Statistics from "./pages/Statistics.jsx";
import Reports from "./pages/report_pages/Reports";
import AddMultiDoseis from "./pages/doseis_pages/AddMultiDoseis.jsx";

function App() {
  const value = {
    ripple: true,
    
};
  return (
    <div>
      <PrimeReactProvider value={value}>
      
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login/>}></Route>
          <Route path="/dashboard" element={<ProtectedRoute allowedRoles={['admin']}><Dashboard/></ProtectedRoute>}></Route>
          {/* <Route path="/map" element={<MapPolution/>}></Route> */}

          <Route path="/users" element={<ProtectedRoute allowedRoles={['admin']}><Users/></ProtectedRoute>}></Route>
          <Route path="/users/add" element={<ProtectedRoute allowedRoles={['admin']}><AddUser/></ProtectedRoute>}></Route>
          <Route path="/users/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><EditUser/></ProtectedRoute>}></Route>

          <Route path="/erga" element={<ProtectedRoute><Erga/></ProtectedRoute>}></Route>
          <Route path="/erga/add" element={<ProtectedRoute allowedRoles={['admin']}><AddErga/></ProtectedRoute>}></Route>
          <Route path="/erga/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><EditErgo/></ProtectedRoute>}></Route>
          <Route path="/erga/profile/:id" element={<ProtectedRoute><ProfileErgo/></ProtectedRoute>}></Route>

          <Route path="/ergacat" element={<ProtectedRoute allowedRoles={['admin']}><ErgaCat/></ProtectedRoute>}></Route>
          <Route path="/ergacat/add" element={<ProtectedRoute allowedRoles={['admin']}><AddErgaCat/></ProtectedRoute>}></Route>
          <Route path="/ergacat/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><EditErgoCat/></ProtectedRoute>}></Route>


          <Route path="/customer" element={<ProtectedRoute><Customer/></ProtectedRoute>}></Route>

          <Route path="/customer/add" element={<ProtectedRoute><AddCustomer/></ProtectedRoute>}></Route>
          <Route path="/customer/edit/:id" element={<ProtectedRoute><EditCustomer/></ProtectedRoute>}></Route>
          <Route path="/customer/profile/:id" element={<ProtectedRoute><ProfileCustomer/></ProtectedRoute>}></Route>


          <Route path="/timologia" element={<ProtectedRoute allowedRoles={['admin']}><Timologia/></ProtectedRoute>}></Route>

          <Route path="/timologia/add" element={<ProtectedRoute allowedRoles={['admin']}><AddTimologio/></ProtectedRoute>}></Route>
          <Route path="/timologia/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><EditTimologio/></ProtectedRoute>}></Route>

          <Route path="/timologia/profile/:id" element={<ProtectedRoute allowedRoles={['admin']}><ProfileTimologio/></ProtectedRoute>}></Route>


          <Route path="/ek_tim" element={<ProtectedRoute allowedRoles={['admin']}><Ekxorimena_Timologia/></ProtectedRoute>}></Route>

          <Route path="/ek_tim/add" element={<ProtectedRoute allowedRoles={['admin']}><AddEkxorimeno_Timologio/></ProtectedRoute>}></Route>
          <Route path="/ek_tim/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><EditEkxorimeno_Timologio/></ProtectedRoute>}></Route>



          <Route path="/ek_tim/profile/:id" element={<ProtectedRoute allowedRoles={['admin']}><ProfileEkxorimenoTimologio/></ProtectedRoute>}></Route>



          <Route path="/paradotea" element={<ProtectedRoute allowedRoles={['admin']}><Paradotea/></ProtectedRoute>}></Route>

          <Route path="/paradotea/add" element={<ProtectedRoute allowedRoles={['admin']}><AddParadoteo/></ProtectedRoute>}></Route>

          <Route path="/paradotea/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><EditParadoteo/></ProtectedRoute>}></Route>

          <Route path="/paradotea/profile/:id" element={<ProtectedRoute allowedRoles={['admin']}><ProfileParadoteo/></ProtectedRoute>}></Route>

          <Route path="/daneia" element={<ProtectedRoute allowedRoles={['admin']}><Daneia/></ProtectedRoute>}></Route>

          <Route path="/daneia/add" element={<ProtectedRoute allowedRoles={['admin']}><AddDaneia/></ProtectedRoute>}></Route>

          <Route path="/daneia/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><EditDaneia/></ProtectedRoute>}></Route>

          <Route path="/daneia/profile/:id" element={<ProtectedRoute allowedRoles={['admin']}><ProfileDaneia/></ProtectedRoute>}></Route>

          <Route path="/tags" element={<ProtectedRoute allowedRoles={['admin']}><Tags/></ProtectedRoute>}></Route>

          <Route path="/tags/add" element={<ProtectedRoute allowedRoles={['admin']}><AddTag/></ProtectedRoute>}></Route>

          <Route path="/tags/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><EditTags/></ProtectedRoute>}></Route>

          <Route path="/tags/profile/:id" element={<ProtectedRoute allowedRoles={['admin']}><ProfileTags/></ProtectedRoute>}></Route>



          <Route path="/doseis" element={<ProtectedRoute allowedRoles={['admin']}><Doseis/></ProtectedRoute>}></Route>

          <Route path="/doseis/add" element={<ProtectedRoute allowedRoles={['admin']}><AddDoseis/></ProtectedRoute>}></Route>
          <Route path="/doseis/multiAdd" element={<ProtectedRoute allowedRoles={['admin']}><AddMultiDoseis/></ProtectedRoute>}></Route>

          <Route path="/doseis/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><EditDoseis/></ProtectedRoute>}></Route>

          <Route path="/doseis/profile/:id" element={<ProtectedRoute allowedRoles={['admin']}><ProfileDoseis/></ProtectedRoute>}></Route>

          <Route path="/ypoquery" element={<ProtectedRoute allowedRoles={['admin']}><Ypoxreoseis/></ProtectedRoute>}></Route>

          <Route path="/ypoquery/add" element={<ProtectedRoute allowedRoles={['admin']}><AddYpoxreoseis/></ProtectedRoute>}></Route>

          <Route path="/ypoquery/profile/:id" element={<ProtectedRoute allowedRoles={['admin']}><ProfileYpoxreoseis/></ProtectedRoute>}></Route>

          <Route path="/ypoquery/edit/:id" element={<ProtectedRoute allowedRoles={['admin']}><EditYpoxreoseis/></ProtectedRoute>}></Route>

          <Route path="/paidView" element={<ProtectedRoute allowedRoles={['admin']}><PaidView/></ProtectedRoute>}></Route>


          <Route path="/tags2" element={<ProtectedRoute allowedRoles={['admin']}><Tags2/></ProtectedRoute>}></Route>

          <Route path="/tags2/add" element={<ProtectedRoute allowedRoles={['admin']}><AddTag2/></ProtectedRoute>}></Route>

          {/* <Route path="/tags/edit/:id" element={<EditTags/>}></Route>

          <Route path="/tags/profile/:id" element={<ProfileTags/>}></Route> */}

          <Route path="/ypoquery2/add" element={<ProtectedRoute allowedRoles={['admin']}><AddYpoxreoseis2/></ProtectedRoute>}></Route>

          <Route path="/ypoquery2" element={<ProtectedRoute allowedRoles={['admin']}><YpoxreoseisList2/></ProtectedRoute>}></Route>

          <Route path="/doseis2/add" element={<ProtectedRoute allowedRoles={['admin']}><AddDoseis2/></ProtectedRoute>}></Route>

          <Route path="/doseis2" element={<ProtectedRoute allowedRoles={['admin']}><Doseis2/></ProtectedRoute>}></Route>

          <Route path="/step1" element={<ProtectedRoute allowedRoles={['admin']}><MyStepper1/></ProtectedRoute>}></Route>

          <Route path="/step2" element={<ProtectedRoute allowedRoles={['admin']}><MyStepper2/></ProtectedRoute>}></Route>

          <Route path="/expen" element={<ProtectedRoute allowedRoles={['admin']}><Expenses_Display/></ProtectedRoute>}></Route>

          <Route path="/budget" element={<ProtectedRoute allowedRoles={['admin']}><BudgetPage/></ProtectedRoute>}></Route>

          <Route path="/customer2" element={<ProtectedRoute allowedRoles={['admin']}><Customer2/></ProtectedRoute>}></Route>

          <Route path="/customer2/add" element={<ProtectedRoute allowedRoles={['admin']}><AddCustomer2/></ProtectedRoute>}></Route>

          <Route path="/erga2" element={<ProtectedRoute allowedRoles={['admin']}><Erga2/></ProtectedRoute>}></Route>

          <Route path="/erga2/add" element={<ProtectedRoute allowedRoles={['admin']}><AddErga2/></ProtectedRoute>}></Route>

          <Route path="/ergacat2" element={<ProtectedRoute allowedRoles={['admin']}><ErgaCat2/></ProtectedRoute>}></Route>
          <Route path="/ergacat2/add" element={<ProtectedRoute allowedRoles={['admin']}><AddErgaCat2/></ProtectedRoute>}></Route>

          <Route path="/paradotea2" element={<ProtectedRoute allowedRoles={['admin']}><Paradotea2/></ProtectedRoute>}></Route>

          <Route path="/paradotea2/add" element={<ProtectedRoute allowedRoles={['admin']}><AddParadoteo2/></ProtectedRoute>}></Route>

          <Route path="/timologia2" element={<ProtectedRoute allowedRoles={['admin']}><Timologia2/></ProtectedRoute>}></Route>

          <Route path="/timologia2/add" element={<ProtectedRoute allowedRoles={['admin']}><AddTimologio2/></ProtectedRoute>}></Route>

          <Route path="/ek_tim2" element={<ProtectedRoute allowedRoles={['admin']}><Ekxorimena_Timologia2/></ProtectedRoute>}></Route>

          <Route path="/ek_tim2/add" element={<ProtectedRoute allowedRoles={['admin']}><AddEkxorimeno_Timologio2/></ProtectedRoute>}></Route>

          <Route path="/esoda_step1" element={<ProtectedRoute allowedRoles={['admin']}><Stepper_Esoda1/></ProtectedRoute>}></Route>
          <Route path="/esoda_step2" element={<ProtectedRoute allowedRoles={['admin']}><Stepper_Esoda2/></ProtectedRoute>}></Route>
          <Route path="/esoda_step3" element={<ProtectedRoute allowedRoles={['admin']}><Stepper_Esoda3/></ProtectedRoute>}></Route>
          {/* <Route path="/statistics2" element={<KpisDashboard/>}></Route> */}
          <Route path="/statistics" element={<ProtectedRoute allowedRoles={['admin']}><Statistics/></ProtectedRoute>}></Route>

          <Route path="/budgetForm" element={<ProtectedRoute allowedRoles={['admin']}><BudgetFormPage/></ProtectedRoute>}></Route>
          <Route path="/reports" element={<ProtectedRoute allowedRoles={['admin']}><Reports/></ProtectedRoute>}></Route>

          <Route path = "/ypoxreoseisstats" element={<ProtectedRoute allowedRoles={['admin']}><YpoxreoseisStatistics/></ProtectedRoute>}></Route>
          <Route path="/statistics_test" element={<ProtectedRoute allowedRoles={['admin']}><KpisDashboardTest/></ProtectedRoute>}></Route>

        </Routes>
      </BrowserRouter>
      </PrimeReactProvider>
    </div>
  );
}

export default App;
